import styled from 'styled-components';

import Button from 'components/shared/Button';
import { mobileTouchExpand } from 'components/shared/responsiveness/touchTarget';
import { colors } from 'styles/theme/colors';

// 24px is the drawn size in every mock these pills appear in, so the tap area grows and the box
// does not. The rule sits here rather than in each panel because all three consumers — the sex
// offender, high cost med and clinical assessment reviews — want the same thing from it.
export const AdjudicationButton = styled(Button)`
  ${mobileTouchExpand}
  height: 24px;
  padding: 0 10px;
  font-size: 12px;
  font-weight: normal;
  line-height: 14px;
  gap: 6px;
  border-radius: 4px;
  border-color: ${colors.black10};
  color: ${colors.black75};
  background: ${colors.white};
`;

export const IconGlyph = styled.span`
  display: inline-flex;
`;

export const DismissedToggleRow = styled.div`
  display: flex;
  justify-content: center;
  position: relative;

  /* The rule the toggle sits on, per the mock. Behind the button so the label reads clear of it. */
  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    border-top: 1px solid ${colors.black10};
  }
`;

export const ViewDismissedButton = styled(Button)`
  ${mobileTouchExpand}
  position: relative;
  height: 24px;
  padding: 0 12px;
  font-size: 12px;
  font-weight: normal;
  line-height: 14px;
  border-radius: 4px;
  border-color: ${colors.black10};
  color: ${colors.black75};
  background: ${colors.white};
`;
